// extracted by mini-css-extract-plugin
export default {"container":"Ip-z","ratingLayout":"Jp-z","ratingLabel":"Kp-z","nonInteractiveRatingLabel":"Lp-z"};